import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useHighlight } from '../../highlight';
import { formatNumber } from '../../utility/formatNumber';
import { getDecimalsCount } from '../utilities/getDecimalsCount';
import { resolve } from '../utilities/intersectionResolver';
import { PeakEditionListener } from './PeakEditionManager';
import { getHighlightExtraId, getHighlightSource, } from './Peaks';
const notationWidth = 10;
const notationMargin = 2;
function PeakAnnotationsTreeStyle(props) {
    const { peaks, peaksSource, spectrumColor, xDomain, displayerKey, peakFormat, } = props;
    const decimalsCount = getDecimalsCount(xDomain[1], peakFormat);
    const mapPeaks = resolve(peaks, {
        key: 'scaleX',
        width: notationWidth,
        margin: notationMargin,
        groupMargin: 10,
    });
    return (_jsx("g", { className: "peaks", clipPath: `url(#${displayerKey}clip-chart-1d)`, children: _jsx("g", { transform: `translate(0,${decimalsCount * 10})`, children: mapPeaks.map((group) => {
                return (_jsx("g", { transform: `translate(${group.meta.groupStartX},0)`, children: group.group.map((item, index) => {
                        const { id, x: value, scaleX, parentKeys } = item;
                        const startX = index * (notationWidth + notationMargin);
                        const x = scaleX - group.meta.groupStartX;
                        return (_jsx(PeakAnnotation, { startX: startX, x: x, id: id, parentKeys: parentKeys, value: value, format: peakFormat, color: spectrumColor, peakEditionFieldPositon: {
                                x: group.meta.groupStartX + startX,
                                y: decimalsCount * 10,
                            }, peaksSource: peaksSource }, id));
                    }) }, group.meta.id));
            }) }) }));
}
function PeakAnnotation(props) {
    const { startX, format, color, id, value, x, peakEditionFieldPositon, peaksSource, parentKeys, } = props;
    const highlight = useHighlight([id], {
        type: getHighlightSource(peaksSource),
        extra: { id: getHighlightExtraId(peaksSource, id, parentKeys) },
    });
    return (_jsxs("g", { onMouseEnter: () => highlight.show(), onMouseLeave: () => highlight.hide(), children: [_jsx(PeakEditionListener, { ...peakEditionFieldPositon, id, value, children: _jsx("text", { transform: `rotate(-90) translate(0 ${startX})`, dominantBaseline: "middle", textAnchor: "start", fontSize: "11px", fill: "black", children: formatNumber(value, format) }) }), _jsx("path", { d: `M ${startX} 5 v 5 L ${x} 20 v 5`, stroke: color, fill: "transparent", strokeWidth: highlight.isActive ? '3px' : '1px' })] }));
}
export default memo(PeakAnnotationsTreeStyle);
